import styles from './Takeaways.module.css'

export const ICON_COLOR_CLASSES = [
  styles.iconBadgeBlue,
  styles.iconBadgePurple,
  styles.iconBadgeTeal,
  styles.iconBadgePink,
]

const colorIndexCache = new Map<string, number[]>()

// Randomly shuffles colour slots once per channel and stores the result in a
// module-level Map, so badge colours stay stable when switching between channels.
export function getColorIndices(channelId: string, count: number): number[] {
  if (!colorIndexCache.has(channelId)) {
    const indices = ICON_COLOR_CLASSES.map((_, i) => i)
    for (let i = indices.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[indices[i], indices[j]] = [indices[j], indices[i]]
    }
    colorIndexCache.set(channelId, indices)
  }
  return (colorIndexCache.get(channelId) ?? []).slice(0, count)
}
